// extracted by mini-css-extract-plugin
module.exports = {"main":"Curation__main--2TSUw","container":"Curation__container--CBXtY","content":"Curation__content--krsz6"};